
import HeaderSecond from '../HeaderSecond'
import event_card_img from '../img/events/event-view.jpg';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoaderImg from '../img/logo/running.gif';
import EventView from '../../src/img/events/event-view.jpg'
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg'
import NoEventImg from '../../src/img/events/no-events.png'
import axios from '../axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserAccessRights } from '../Custom';

const EditEvent = () => {

    const navigate = useNavigate();
    const DivRef = useRef(null);
    const [Section, setSection] = useState('my-profile');
    const [EventInfoStatus, setEventInfoStatus] = useState(1);
    const [EventPublicStatus, setEventPublicStatus] = useState('active');
    const [EventPrivateStatus, setEventPrivateStatus] = useState('');
    const [EventDraftStatus, setEventDraftStatus] = useState('');
    const [EventStatus, setEventStatus] = useState(false);
    const [EventFlag, setEventFlag] = useState(false);

    const [AllEventData, setAllEventData] = useState([]);
    const [ConfirmPopup, setConfirmPopup] = useState(false);
    const [EventEditId, setEventEditId] = useState('');
    const [EventType, setEventType] = useState('');
    const [ActionFlag, setActionFlag] = useState('');

    const [ActionableFlag, setActionableFlag] = useState(false);

    const [evntStatus, setevntStatus] = useState('');
    const [eventIndex, seteventIndex] = useState('');

    const [AllOrgEventData, setAllOrgEventData] = useState([]);
    const [Loader, setLoader] = useState(false);
    const [ShowSuggestion1, setShowSuggestion1] = useState(false);
    const [EventList, setEventList] = useState('');
    const [Val1, setVal1] = useState('');
    const [EventSuggestions, setEventSuggestions] = useState([]);

    const handleClose = (e) => {
        if (DivRef.current && !DivRef.current.contains(e.target)) {
            setShowSuggestion1(false);
        }
    }

    //---------- event
    const handleEventChange = (e) => {
        const value = e.target.value;
        setVal1(value);
        if (value === "") {
            setEventList('');
        }
        if (AllEventData && AllEventData.length > 0) {
            const filteredSuggestions = AllEventData.filter((item) =>
                item.name.toLowerCase().includes(value.toLowerCase())
            );

            const SliceArr = filteredSuggestions.slice(0, 5)
            setEventSuggestions(SliceArr);
            setShowSuggestion1(true);
        }

    };
    const handleEventSuggestionClick = (e, id, name) => {
        setEventList(id);
        setVal1(name)
        setEventSuggestions([]);
        // handleSubmit(e)
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!DivRef.current) return;
            if (!DivRef.current.contains(event.target)) {
                setShowSuggestion1(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const HandleClear = (e) => {
        e.preventDefault();
        setVal1(''); setEventList('');
        setEventFlag(true);
    }

    useEffect(() => {
        setLoader(true);
        const payload = {
            event_id: EventList ? EventList : 0,
            event_info_status: EventInfoStatus !== 0 ? EventInfoStatus : 0,
            login_as_organiser_id: localStorage.getItem("LoginAsOrganiser") ? localStorage.getItem("LoginAsOrganiser") : 0
        };
        // console.log(payload);
        axios.post("AllEventDetails", payload)
            .then((response) => {
                //   console.log(response.data.data);
                if (response.status === 200) {
                    setAllEventData(response.data.data.event_data);
                    setAllOrgEventData(response.data.data.org_event_data ? response.data.data.org_event_data : []);
                    setEventFlag(false);
                    setLoader(false);
                }
            })
            .catch((error) => {
                setLoader(false);
                console.log(error);
            })

    }, [EventFlag, EventInfoStatus])
    // console.log(AllOrgEventData);

    useEffect(() => {
        if(EventEditId){
            setLoader(true);
            const payload = {
                event_edit_id: EventEditId ? EventEditId : 0
            };
            // console.log(payload);
            axios.post("event_edit_details", payload)
                .then((response) => {
                    setLoader(false);
                })
                .catch((error) => {
                    setLoader(false);
                    console.log(error);
                })
        }
    }, [EventEditId])

    const ChangeEventStatus = (event, index, actionFlag) => {
        //console.log(event,index);

        if (actionFlag == 'delete') {
            setConfirmPopup(true);
            // ActionDeleteChangeStatus('','','');
        } else if (actionFlag == 'change_status') {
            setConfirmPopup(true);
            // StatusChange(event,index,actionFlag);
        }
    }


    const ActionDeleteChangeStatus = () => {

        if (ActionFlag == 'change_status') {
            let EventArray = [...AllEventData];
            EventArray[eventIndex]['event_status'] = !evntStatus;
            setAllEventData(EventArray);
        }

        // console.log(ActionFlag);
        const payload = {
            event_id: EventEditId,
            event_status: evntStatus,
            action_flag: ActionFlag
        };
        //console.log(payload);
        axios.post("EventDeleteChangeStatus", payload)
            .then((response) => {
                //   console.log(response.data.data);
                if (response.status === 200) {
                    if (ActionFlag == "change_status") {
                        toast.success(response.data.message)
                    } else {
                        toast.error(response.data.message)
                    }
                    setEventFlag(true);
                    setevntStatus('');
                    seteventIndex('');
                    setEventStatus(false)
                }
            })
            .catch((error) => {
                console.log(error);
            })
    }

    // const ChangeEditEvent = (eventId, eventType) => {
    //     // console.log(eventId,eventType);
    //     localStorage.setItem("EventId", eventId);
    //     localStorage.setItem("EventType", eventType);
    //     navigate('/create_events');
    // }
    const ChangeEditEvent = (eventId, eventType) => {
        navigate("/create_events", {
            state: {
            eventId,
            eventType,
            },
        });
        localStorage.setItem("EventType", eventType);
    };

    const handleBackToHome = () => {
        localStorage.removeItem('EventViewFlag');
        localStorage.removeItem('EventDetailsId');

        const CountryCode = localStorage.getItem('CountryCode');
        const CountryName = localStorage.getItem('Country');
        navigate('/' + CountryCode + '/' + CountryName);
    }

    //--------------- access rights
    // const AccessRightFlag = localStorage.getItem("Access_Right_Flag");
    // const OrgUserAccessModules = localStorage.getItem("OrgUserAccessModules") ? JSON.parse(localStorage.getItem("OrgUserAccessModules")) : '';

    //-------------- To check user access rights
    const [OrgUserAccessModules, setOrgUserAccessModules] = useState({});
    useEffect(() => {
        axios.post("user_access_rights", {})
            .then((response) => {
                // console.log(response.data.data.user_access_rights);
                setOrgUserAccessModules(response.data.data.user_access_rights);
            })
            .catch((error) => {
                console.error("Access rights error:", error);
            });
    }, []);
    useEffect(() => {
        if (OrgUserAccessModules) {
            const access = UserAccessRights({ module_name: "Event", module_display: "yes", Data: OrgUserAccessModules });
            if (access === true) {
                alert("You don't have any access to this module");
                navigate('/');
            }
        }
    }, [OrgUserAccessModules]);

    const handleEventDetails = (e, EventName) => {
        let isPassiloStaging = window.location.pathname.includes("passilo_staging");
        let url = '';
        if (isPassiloStaging) {
            url = "/passilo_staging/e/" + EventName.replace(/\s/g, '_');
        } else {
            url = "/e/" + EventName.replace(/\s/g, '_');
        }
        window.open(url, "_blank");
    };

    return (
        <>
            {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}
            {
                ConfirmPopup && (

                    <div className="modal is-visible" data-animation="slideInUp">
                        <div className="modal-dialog quickview__main--wrapper">
                            <div className="quickview__inner">
                                <div className="row">
                                    <div className="login__section">
                                        <div className="login__section--inner">
                                            <div className="p-5">
                                                <div className="account__login--header mb-25">
                                                    {ActionFlag && ActionFlag === 'delete' ?
                                                        <p className="account__login--header__desc">Are you sure you want to delete this event?</p>

                                                        : ActionFlag && ActionFlag === 'edit' ?
                                                            <p className="account__login--header__desc">Are you sure you want to edit this event?</p>
                                                            :
                                                            <p className="account__login--header__desc">Are you sure to change status this event?</p>
                                                    }
                                                </div>
                                                <div className="d-flex gap-4">
                                                    <button className="account__login--btn secondary__btn mt-2" onClick={() => {
                                                        setConfirmPopup(false); setActionableFlag(false);
                                                    }}>Cancel</button>

                                                    {ActionFlag && ActionFlag === 'edit' ?
                                                        <button className="account__login--btn primary__btn mt-2" onClick={(e) => { setConfirmPopup(false); ChangeEditEvent(EventEditId, EventType); setActionableFlag(false); }}>Yes</button>
                                                        :
                                                        <button className="account__login--btn primary__btn mt-2" onClick={(e) => { setConfirmPopup(false); setActionableFlag(true); ActionDeleteChangeStatus(); }}>Yes</button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            <HeaderSecond />
            <ToastContainer theme="colored" />
            <main className="main__content_wrapper">
                <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
                    <div className="container">
                        <div className="row row-cols-1">
                            <div className="col">
                                <div className="breadcrumb__content">
                                    <h1 className="breadcrumb__content--title text-white mb-10">
                                        My Events
                                    </h1>
                                    {/* <ul className="breadcrumb__content--menu d-flex">
                                        <li className="breadcrumb__content--menu__items">
                                            <div className="text-white" onClick={(e) => handleBackToHome(e)}>
                                                Home
                                            </div>
                                        </li>
                                        <li className="breadcrumb__content--menu__items">
                                            <span className="text-white">My Events</span>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="section--padding  pt-5">
                    <div className="container">
                        {/* use class "saved" when the form is filled with save and replace it with the tick mark icon SVG.  */}
                        {/* Use class "active" when form is active */}
                        <div className="row">
                            <div className="col-sm-3 d-flex align-items-left justify-content-left     align-items-center my-0 pb-0">
                                <div className="event-visibility hand_cursor">
                                    <div className={'visibility gap-1 ' + EventPublicStatus} onClick={() => { setEventInfoStatus(1); setEventPublicStatus('active'); setEventPrivateStatus(''); setEventDraftStatus(''); }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height={20}
                                            viewBox="0 -960 960 960"
                                            width={20}
                                        >
                                            <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-40-82v-78q-33 0-56.5-23.5T360-320v-40L168-552q-3 18-5.5 36t-2.5 36q0 121 79.5 212T440-162Zm276-102q20-22 36-47.5t26.5-53q10.5-27.5 16-56.5t5.5-59q0-98-54.5-179T600-776v16q0 33-23.5 56.5T520-680h-80v80q0 17-11.5 28.5T400-560h-80v80h240q17 0 28.5 11.5T600-440v120h40q26 0 47 15.5t29 40.5Z" />
                                        </svg>
                                        Public
                                    </div>

                                    <div className={'visibility gap-1 ' + EventPrivateStatus} onClick={() => { setEventInfoStatus(2); setEventPublicStatus(''); setEventPrivateStatus('active'); setEventDraftStatus(''); }} >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height={20}
                                            viewBox="0 -960 960 960"
                                            width={20}
                                        >
                                            <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
                                        </svg>
                                        Private
                                    </div>

                                    <div className={'visibility gap-1 ' + EventDraftStatus} onClick={() => { setEventInfoStatus(3); setEventPublicStatus(''); setEventPrivateStatus(''); setEventDraftStatus('active'); }} >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height={20}
                                            viewBox="0 -960 960 960"
                                            width={20}
                                        >
                                            <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
                                        </svg>
                                        Draft
                                    </div>

                                </div>
                            </div>

                            <div className="col-sm-3 d-flex align-items-left justify-content-left mt-2">
                                <div className="checkout__input--list">
                                    <div className="checkout__input--list my-2">
                                        <input className="predictive__search--input" placeholder="Select Event Name" type="text" onChange={(e) => { handleEventChange(e); }} value={Val1} />
                                        <div className="autocomplete" style={{ cursor: 'pointer' }}>
                                            {ShowSuggestion1 ?
                                                <ul ref={DivRef} style={{ width: 'auto', padding: '0px 20px 0px 5px' }}>
                                                    {
                                                        (EventSuggestions.length > 0) ?
                                                            EventSuggestions.map((item) => {
                                                                // console.log(item);
                                                                return (
                                                                    <li key={item.id}
                                                                        onClick={(e) => handleEventSuggestionClick(e, item.id, item.name)}
                                                                    >{item.name}</li>
                                                                )
                                                            }) : null
                                                    }
                                                </ul>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-3 d-flex align-items-left justify-content-left     align-items-center my-0 pb-0">
                                <div className="checkout__content--step__footer d-flex align-items-center flex-row justify-content-center gap-4 hand_cursor">

                                    <div className="continue__shipping--btn secondary__btn border-radius-5" onClick={(e) => HandleClear(e)}>
                                        Clear
                                    </div>
                                    <div className="continue__shipping--btn primary__btn border-radius-5" onClick={(e) => setEventFlag(true)} >
                                        Search
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <hr /> */}
                        <div className="row mt-5" >
                            {/* {console.log(AllEventData)} */}
                            {AllEventData && AllEventData.length > 0 ?
                                AllEventData.map((event, index) => (
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 position-relative" key={index}>
                                        <div className="product__items mt-4 mb-5" >

                                            <div className="product__items--thumbnail" >
                                                <div className="product__items--link">
                                                    <img
                                                        className="product__items--img product__primary--img"
                                                        src={event.banner_image || EventView}
                                                        alt="Event View"
                                                        style={{ height: '230px', objectFit: 'fill' }}
                                                    />
                                                </div>


                                                {/* New Event date */}
                                                <div className='event-date-card'>
                                                    <p className="m-0 event-month-value">{event.start_event_month ? event.start_event_month : null}</p>
                                                    <p className="m-0 event-date-value">{event.start_event_date ? event.start_event_date : null}</p>
                                                </div>

                                                <div className="product__badge style1 special-badge gap-1" >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="#323131ff"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> {event.city}
                                                </div>

                                                {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                    event.TicketDetails.some(ticket => (parseInt(ticket.show_early_bird) === 1 && parseInt(ticket.ticket_status) !== 2)) ? (

                                                        <div className="product__badge_early_bird style1 special-badge gap-1" title='Early Bird'>
                                                            {/* Early Bird */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M480-80q-24 0-46-9t-39-26q-29-29-50-38t-63-9q-50 0-85-35t-35-85q0-42-9-63t-38-50q-17-17-26-39t-9-46q0-24 9-46t26-39q29-29 38-50t9-63q0-50 35-85t85-35q42 0 63-9t50-38q17-17 39-26t46-9q24 0 46 9t39 26q29 29 50 38t63 9q50 0 85 35t35 85q0 42 9 63t38 50q17 17 26 39t9 46q0 24-9 46t-26 39q-29 29-38 50t-9 63q0 50-35 85t-85 35q-42 0-63 9t-50 38q-17 17-39 26t-46 9Zm100-240q25 0 42.5-17.5T640-380q0-25-17.5-42.5T580-440q-25 0-42.5 17.5T520-380q0 25 17.5 42.5T580-320Zm-202-2 260-260-56-56-260 260 56 56Zm2-198q25 0 42.5-17.5T440-580q0-25-17.5-42.5T380-640q-25 0-42.5 17.5T320-580q0 25 17.5 42.5T380-520Z" /></svg>
                                                        </div>
                                                    ) : null
                                                )}

                                                <ul className="product__items--action d-flex justify-content-center">

                                                   
                                                    {OrgUserAccessModules.Event === 2 ?
                                                        <>
                                                            <li className="product__items--action__list">
                                                                <div className="product__items--action__btn hand_cursor tooltip" onClick={() => { setConfirmPopup(true); setActionFlag('edit'); setEventEditId(event.id); setEventType(event.event_type); }} >

                                                                    <svg
                                                                        className="product__items--action__btn--svg"
                                                                        xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" >

                                                                        <path d="M80 0v-160h800V0H80Zm160-320h56l312-311-29-29-28-28-311 312v56Zm-80 80v-170l448-447q11-11 25.5-17t30.5-6q16 0 31 6t27 18l55 56q12 11 17.5 26t5.5 31q0 15-5.5 29.5T777-687L330-240H160Zm560-504-56-56 56 56ZM608-631l-29-29-28-28 57 57Z"
                                                                            transform="translate(0 0)"
                                                                            fill="currentColor"
                                                                        />
                                                                    </svg>
                                                                    <span className="visually-hidden">Edit</span>
                                                                    <span className="tooltiptext position-fixed w-auto">Edit Event</span>
                                                                </div>
                                                            </li>
                                                        {event.event_delete_flag == 1 ?
                                                            <li className="product__items--action__list">
                                                                <div className="product__items--action__btn hand_cursor tooltip" onClick={(e) => { ChangeEventStatus(e, index, 'delete'); setActionFlag('delete'); setEventEditId(event.id); setEventType(event.event_type); }}>

                                                                    <svg
                                                                        className="product__items--action__btn--svg"
                                                                        xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" >
                                                                        <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                                                                            transform="translate(0 0)"
                                                                            fill="currentColor"
                                                                            title="ss"
                                                                        />
                                                                    </svg>
                                                                    <span className="visually-hidden">Delete</span>
                                                                    <span className="tooltiptext position-fixed w-auto">Delete Event</span>
                                                                </div>
                                                            </li>
                                                         : null }
                                                        </>
                                                    : null }

                                                    <li className="product__items--action__list">
                                                        <div className="product__items--action__btn hand_cursor tooltip" onClick={(e) => handleEventDetails(e, event.name)} >
                                                            <svg
                                                                className="product__items--action__btn--svg"
                                                                xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" >

                                                                <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-480H200v480Zm280-80q-82 0-146.5-44.5T240-440q29-71 93.5-115.5T480-600q82 0 146.5 44.5T720-440q-29 71-93.5 115.5T480-280Zm0-60q56 0 102-26.5t72-73.5q-26-47-72-73.5T480-540q-56 0-102 26.5T306-440q26 47 72 73.5T480-340Zm0-100Zm0 60q25 0 42.5-17.5T540-440q0-25-17.5-42.5T480-500q-25 0-42.5 17.5T420-440q0 25 17.5 42.5T480-380Z"
                                                                    transform="translate(0 0)"
                                                                    fill="currentColor"
                                                                />
                                                            </svg>

                                                            <span className="tooltiptext position-fixed w-auto">Preview</span>
                                                        </div>
                                                    </li>

                                                </ul>

                                            </div>

                                            {/* event info */}
                                            <div className="product__items--content cursor-pointer" >

                                                {/* Event Name */}
                                                <div className=" pt-2">
                                                    <h4 className="h4 d-flex" style={{ height: "55px", overflow: "hidden" }}>  {event.event_name !== '' && event.event_name !== null ? event.event_name : event.display_name !== null ? event.display_name : ''}</h4>
                                                </div>

                                                {/* Location and like & share btn */}
                                                <div className="row d-flex align-items-center py-3" style={{ borderBottom: "1px dashed #c7c7c7" }}>
                                                    <div className="col-sm-7">
                                                        {event.venue ?
                                                            <p className='card-rgn-txt overflow-text'> <strong>
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#383434"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> <span className="rgn-date">{event.venue}</span></strong>
                                                            </p>
                                                            : null}
                                                    </div>

                                                    <div className="col-sm-5 ps-0">
                                                        <ul className="product__items--action d-flex justify-content-end">
                                                    
                                                            {OrgUserAccessModules.Insight === 1 || OrgUserAccessModules.Insight === 2 ?
                                                                <div className='report-icon tooltip' onClick={(e) => { navigate('/event_dashboard', { state: { eventId: event.id, event_name: event.event_name } }); }} style={{ display: 'inline-flex', alignItems: 'flex-end' }} >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M640-160v-280h160v280H640Zm-240 0v-640h160v640H400Zm-240 0v-440h160v440H160Z" /></svg>
                                                                    <p style={{ fontSize: '14px' }}>&nbsp;View Insights</p>
                                                                </div>
                                                            : null}
                                                           
                                                        </ul>
                                                    </div>
                                                </div>


                                                {/* amount and action btn */}
                                                <div className="d-flex align-items-center justify-content-between py-3 px-2">
                                                    <div className="">
                                                        {event.TicketDetails && event.TicketDetails.length > 0 ?
                                                            <h4 className="h4 d-flex align-items-center gap-1">
                                                                
                                                                {/* <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="currentColor"><path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" /></svg>

                                                                {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                                    event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                                                        <span>Free</span>
                                                                    ) : (

                                                                        event.TicketDetails.map((ticket, index) => (
                                                                            parseInt(ticket.ticket_status) === 1 && (
                                                                                <span key={index}>
                                                                                   
                                                                                    {ticket.show_early_bird === 1 ? (
                                                                                        <span > {ticket.ticket_price}</span>
                                                                                    ) : (
                                                                                        <span>{ticket.ticket_price}</span>
                                                                                    )}
                                                                                </span>
                                                                            )
                                                                        ))
                                                                    )
                                                                )}
                                                                <small className="fw-normal fs-5 mt-1"> Onwards</small> */}

                                                                {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                                event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                                                    <span className="current__price m-0">Free</span>
                                                                ) : (
                                                                    event.TicketDetails.map((ticket, index) => (
                                                                    parseInt(ticket.ticket_status) === 1 && (
                                                                        <span key={index}>
                                                                        {index > 0 && " - "}
                                                                        {ticket.show_early_bird === 1 ? (
                                                                            <span className="text-left">
                                                                            <span className="ticket-prices">
                                                                                <span className="original-price"> ₹{ticket.ticket_price}</span>&nbsp;
                                                                                <span className="current__price m-0">₹{ticket.discount_ticket_price}</span>
                                                                            </span>
                                                                            </span>
                                                                        ) : (
                                                                            <span className="current__price m-0">₹{ticket.ticket_price}</span>
                                                                        )}
                                                                        <small className="fw-normal fs-5 mt-1"> Onwards</small>
                                                                        </span>
                                                                    )
                                                                    ))
                                                                )
                                                                )}
                                                              </h4>
                                                            : null}
                                                    </div>

                                                   
                                                    {OrgUserAccessModules.Event === 2 && event.event_delete_flag == 1  ?
                                                        <div className="col-4 col-sm-4 my-0 text-right tooltip">
                                                            <div className="form-check form-switch d-flex align-items-left justify-content-end my-2 ">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    role="switch"
                                                                    value={event.event_status}
                                                                    checked={event.event_status}
                                                                    onChange={(e) => setEventStatus(!EventStatus)}
                                                                    onClick={(e) => { ChangeEventStatus(e, index, 'change_status'); setActionFlag('change_status'); setEventEditId(event.id); setEventType(event.event_type); setevntStatus(event.event_status); seteventIndex(index); }}
                                                                />

                                                            </div>
                                                            <span className="tooltiptext position-fixed w-auto">Event {event.event_status === true ? 'Active' : 'Deactive'}</span>
                                                        </div>
                                                    : null}
                                                      
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ))
                                :

                                <div className="product__section--inner py-5 text-center">
                                    <img src={NoEventImg} alt="" style={{ width: 250 }} />
                                    <h4 className="pt-4">No events found</h4>
                                    <p>
                                        Sorry, There are no events added yet. Please design your event now!
                                    </p>
                                </div>

                            }
                        </div>

                        {/* -------------------------------------------------------------------------------------------- */}

                        {/* {AllOrgEventData && AllOrgEventData.length > 0 ?
                            <>
                                <hr className='my-2' style={{ background: 'lightgrey' }} />
                                <div className="row mt-4">

                                    <h3>Organiser Events</h3> <br /><br /><br />

                                    {AllOrgEventData && AllOrgEventData.length > 0 ?
                                        AllOrgEventData.map((event, index) => (
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 position-relative" key={index}>
                                                <div className="product__items mt-4 mb-5" >
                                                    <div className="product__items--thumbnail" >
                                                        <div className="product__items--link">
                                                            <img
                                                                className="product__items--img product__primary--img"
                                                                src={event.banner_image || EventView}
                                                                alt="Event View"
                                                                style={{ height: '230px', objectFit: 'fill' }}
                                                            />
                                                        </div>

                                                        <div className='event-date-card'>
                                                            <p className="m-0 event-month-value">{event.start_event_month ? event.start_event_month : null}</p>
                                                            <p className="m-0 event-date-value">{event.start_event_date ? event.start_event_date : null}</p>
                                                        </div>

                                                        <div className="product__badge style1 special-badge gap-1" >
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="#323131ff"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> {event.city}
                                                        </div>


                                                        {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                            event.TicketDetails.some(ticket => (parseInt(ticket.show_early_bird) === 1 && parseInt(ticket.ticket_status) !== 2)) ? (

                                                                <div className="product__badge_early_bird style1 special-badge gap-1" title='Early Bird'>

                                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M480-80q-24 0-46-9t-39-26q-29-29-50-38t-63-9q-50 0-85-35t-35-85q0-42-9-63t-38-50q-17-17-26-39t-9-46q0-24 9-46t26-39q29-29 38-50t9-63q0-50 35-85t85-35q42 0 63-9t50-38q17-17 39-26t46-9q24 0 46 9t39 26q29 29 50 38t63 9q50 0 85 35t35 85q0 42 9 63t38 50q17 17 26 39t9 46q0 24-9 46t-26 39q-29 29-38 50t-9 63q0 50-35 85t-85 35q-42 0-63 9t-50 38q-17 17-39 26t-46 9Zm100-240q25 0 42.5-17.5T640-380q0-25-17.5-42.5T580-440q-25 0-42.5 17.5T520-380q0 25 17.5 42.5T580-320Zm-202-2 260-260-56-56-260 260 56 56Zm2-198q25 0 42.5-17.5T440-580q0-25-17.5-42.5T380-640q-25 0-42.5 17.5T320-580q0 25 17.5 42.5T380-520Z" /></svg>
                                                                </div>
                                                            ) : null
                                                        )}

                                                    </div>

                                                        <div className="product__items--content cursor-pointer" >

                                                <div className=" pt-2">
                                                    <h4 className="h4 d-flex" style={{ height: "55px", overflow: "hidden" }}>  {event.event_name !== '' && event.event_name !== null ? event.event_name : event.display_name !== null ? event.display_name : ''}</h4>
                                                </div>

                                                <div className="row d-flex align-items-center py-3" style={{ borderBottom: "1px dashed #c7c7c7" }}>
                                                    <div className="col-sm-7">
                                                        {event.venue ?
                                                            <p className='card-rgn-txt overflow-text'> <strong>
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#383434"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> <span className="rgn-date">{event.venue}</span></strong>
                                                            </p>
                                                            : null}
                                                    </div>

                                                    <div className="col-sm-5 ps-0">
                                                        <ul className="product__items--action d-flex justify-content-end">

                                                            {AccessRightFlag === '1' ?
                                                                <>
                                                                    {OrgUserAccessModules.Insight === 1 || OrgUserAccessModules.Insight === 2 ?
                                                                        <div className='report-icon tooltip' onClick={(e) => { navigate('/event_dashboard/' + event.id, { state: { event_name: event.event_name } }); }} style={{ display: 'inline-flex', alignItems: 'flex-end' }} >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M640-160v-280h160v280H640Zm-240 0v-640h160v640H400Zm-240 0v-440h160v440H160Z" /></svg>
                                                                            <p style={{ fontSize: '14px' }}>&nbsp;View Insights</p>
                                                                        </div>
                                                                        : null}
                                                                </>
                                                                :
                                                                <div className='report-icon tooltip' onClick={(e) => { navigate('/event_dashboard/' + event.id, { state: { event_name: event.event_name } }); }} style={{ display: 'inline-flex', alignItems: 'flex-end' }}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M640-160v-280h160v280H640Zm-240 0v-640h160v640H400Zm-240 0v-440h160v440H160Z" /></svg>

                                                                    <p style={{ fontSize: '14px' }}>&nbsp;View Insights</p>
                                                                </div>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="d-flex align-items-center justify-content-between py-3 px-2">
                                                    <div className="">
                                                        {event.TicketDetails && event.TicketDetails.length > 0 ?
                                                            <h4 className="h4 d-flex align-items-center gap-1"><svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="currentColor"><path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" /></svg>

                                                                {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                                    event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                                                        <span>Free</span>
                                                                    ) : (

                                                                        event.TicketDetails.map((ticket, index) => (
                                                                            parseInt(ticket.ticket_status) === 1 && (
                                                                                <span key={index}>
                                                                                   
                                                                                    {ticket.show_early_bird === 1 ? (
                                                                                        <span > {ticket.ticket_price}</span>
                                                                                    ) : (
                                                                                        <span>{ticket.ticket_price}</span>
                                                                                    )}
                                                                                </span>
                                                                            )
                                                                        ))
                                                                    )
                                                                )}
                                                                <small className="fw-normal fs-5 mt-1"> Onwards</small></h4>
                                                            : null}
                                                    </div>

                                                </div>

                                            </div>
                                                </div>
                                            </div>
                                        ))
                                        :

                                        <div className="product__section--inner py-5 text-center">
                                            <img src={NoEventImg} alt="" style={{ width: 250 }} />
                                            <h4 className="pt-4">No events found</h4>
                                            <p>
                                                Sorry, There are no events added yet. Please design your event now!
                                            </p>
                                        </div>

                                    }
                                </div>
                            </>
                        : null} */}
                        
                    </div>
                </section>


            </main>
        </>

    )
}

export default EditEvent